import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import collectionsReducer from "./slices/collections";
import uiReducer from "./slices/ui";
import { hgApi } from "../../api/api";

export const store = configureStore({
  reducer: {
    collections: collectionsReducer,
    ui: uiReducer,
    [hgApi.reducerPath]: hgApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(hgApi.middleware),
});

// Infer the type of `store`
export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore["dispatch"];
// Define a reusable type describing thunk functions
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>;
